import { convertingSecondIntoHoursFormat } from "./convertingSecondIntoHoursFormat";
import { formatDate } from "./formatDate";
import Default from "assets/img/default-img.jpg";

const deginType = [
  { value: "gold", icon: "gold" },
  { value: "silver", icon: "silver" },
  { value: "bronze", icon: "bronze" },
  { value: "under ratio", icon: "under ratio" },
];

const laborData = [
  { value: "R", icon: "r_labor" },
  { value: "X", icon: "x_labor" },
  { value: "H", icon: "h_labor" },
  { value: "X2", icon: "x2_labor" },
  { value: "X5", icon: "x5_labor" },
  { value: "X8", icon: "x8_labor" },
  { value: "XX", icon: "xx_labor" },
];

const cupData = [
  { value: "Gold", icon: "gold_cup" },
  { value: "Silver", icon: "silver_cup" },
  { value: "Bronze", icon: "bronze_cup" },
];

const transformData = (design) => {
  const obj = {
    id: design._id ? design._id : design.id,
    // labour: design.makeType ? design.makeType : design.labour,
    // date: design.styleDate ? new Date(design.styleDate).toLocaleDateString("en-GB") : design.date,
    date: design.styleDate ? formatDate(design?.styleDate) : design.date,
    // gold: design.styleNumber ? design.styleNumber : design.gold,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // diamond: design.diaPcs != null && design.diaWeight != null ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // weight: design.grossWeight ? `${design.grossWeight}/${design.netWeight}` : design.weight,
    diamond: design.diaPcs != null && design.diaWeight != null ? `${design.diaWeight} Ct / ${design.diaPcs} Pcs` : design.diamond,
    // weight: design.grossWeight ? `${design.n/etWeight} g / ${design.grossWeight} g` : design.weight,
    weight: design.grossWeight ? `${design.netWeight} g / ${design.grossWeight} g` : `${design.netWeight} g / ${design.grossWeight} g`,
    colorStoneWeight: design?.colorStoneWeight || 0.0,
    colorStonePcs: design?.colorStonePcs || 0,
    otherMaterialWeight: design?.otherMaterialWeight || 0.0,
    otherMaterialPcs: design?.otherMaterialPcs || 0,
    collectionDetails: design.collectionDetails || [],
    setDetails: design.setDetails || [],
    sales: design?.totalSales || 0,
    trendUp: true,
    cup: cupData.find((item) => item.value === design?.currentTrophy)?.icon || null,
    bestSeller: design?.bestSeller ? true : false,
    labour: laborData.find((item) => item.value === design?.makeType)?.icon,
    // img: design?.imageUrl,
    img: design?.transformedImageUrl,
    Orgimg: design?.imageUrl,
    designClass: deginType?.find((item) => item?.value === design?.designClass?.toLowerCase())?.icon,
    styleNumber: design?.styleNumber || null,
    totalTrophy: design?.totalTrophy || null,
    cadIcon: design?.cadIcon || false,
    restrictDate: design?.restrict ? (design?.autoRestrict ? design?.autoRestrictDate : design?.manualRestrictDate) : null,
    restrictIcon: design?.restrict ? (design?.autoRestrict ? "autoRestrictedIcon" : design?.manualRestrictDate ? "manualRestrictedIcon" : null) : null,
    stockCount: design?.stocks || null,
    categoryName: design?.categoryName || null,
    subCategoryName: design?.subCategoryName || null,
    itemSize: design?.itemSize || null,
    diaQlty: design?.diaQlty || "VVS-GH", // "VVS-EF", "VVS-FG", "VVS-GH", "VS-GH", "VSSI-GH", "SI-HI", "SI-IJ"
    goldQlty: design?.goldQlty || "18", //14 ,18
    goldColor: design?.goldColor || "P", //P ,Y ,W
    relavantSetsDesign: design?.relavantSetsDesign?.length > 0 ? design?.relavantSetsDesign : [],
    totalClientSales: design?.totalClientSales,
    reorderData: design?.reorderData || null,
    ratio: design?.ratio?.toFixed(2) || "N/A",
    isHidden: design?.isHidden || false,
  };

  return obj;
};

const transformSetData = (set) => {
  const defaultImageUrl = Default;

  // Create an array of images, slicing the first 4 and filling missing with the default image
  // const designsImgs = [...set?.designImages?.slice(0, 4).map((design) => ({ image: design?.transformedImageUrl }))];

  // Create an array of flattened designs for reference
  const allDesigns = set?.designs?.flat() || [];

  // Extract first 4 images and attach isPurchased info
  const designsImgs =
    set?.designImages?.slice(0, 4).map((designImg) => {
      const relatedDesign = allDesigns.find((d) => d.styleNumber === designImg.styleNumber);
      return {
        image: designImg?.transformedImageUrl || defaultImageUrl,
        isPurchased: relatedDesign?.isPurchase || false,
      };
    }) || [];

  // for the max makeType calculation
  let makeTypes = set?.designs[0];
  const map = new Map();
  for (let i = 0; i < makeTypes.length; i++) {
    const type = makeTypes[i].makeType;

    if (map.has(type)) {
      map.set(type, map.get(type) + 1);
    } else {
      map.set(type, 1);
    }
  }
  const mostFrequentMakeType = [...map.entries()].reduce(
    (max, [type, count]) => {
      return count > max.count ? { type, count } : max;
    },
    { type: null, count: 0 }
  );

  // for the max metal type
  const MetalTypes = set?.designs[0]?.reduce((acc, design, ind) => {
    const metalType = design?.designClass?.toLowerCase();
    if (!metalType) return acc;
    acc[metalType] = (acc[metalType] || 0) + 1;
    return acc;
  }, {});

  const maxMetal = Object.entries(MetalTypes).reduce(
    (acc, [key, val]) => {
      return val > acc.value ? { key, value: val } : acc;
    },
    { key: null, value: -Infinity }
  );

  const trophyCount = set?.designs?.flat()?.reduce((acc, design) => {
    if (design.currentTrophy) {
      acc[design.currentTrophy] = (acc[design.currentTrophy] || 0) + 1;
    }
    return acc;
  }, {});

  const priority = ["Gold", "Silver", "Bronze"];

  const mostFrequentTrophy = priority.find((trophy) => trophyCount?.[trophy] > 0);

  const cup = cupData.find((item) => item.value === mostFrequentTrophy)?.icon || null;

  const totalSales = set?.designs.flat().reduce((sum, design) => sum + (design.totalSales || 0), 0);

  const salesAverage = totalSales / set?.designs?.flat()?.length || 0;

  return {
    _id: set._id,
    setNumber: set.setNumber,
    // totalDiamonds: `${set.totalDiaPcs}/${set.totalDiaWeight.toFixed(2)}`,
    // goldWeights: `${set.totalGoldGrossWeight.toFixed(2)}/${set.totalGoldWeight.toFixed(2)}`,
    totalDiamonds: `${set.totalDiaWeight.toFixed(2)} Ct / ${set.totalDiaPcs} Pcs`,
    goldWeights: `${set.totalGoldWeight.toFixed(2)} g / ${set.totalGoldGrossWeight.toFixed(2)} g`,
    numberOfStyles: set.numberOfStyles,
    // date: new Date(set.createdAt).toLocaleDateString("en-GB"),
    date: formatDate(set.createdAt),
    designsImgs,
    labour: mostFrequentMakeType.type,
    maxMetalType: maxMetal?.key,
    sales: totalSales,
    salesAverage: Math.floor(salesAverage * 100) / 100,
    trendUp: true,
    // cup: cupData.find((item) => item.value === "GoldCup")?.icon,
    cup: cup,
    totalCupCount: set?.designs.flat().reduce((sum, design) => sum + (design.totalTrophy || 0), 0),
    bestSeller: set?.designs[0]?.some((design) => design.bestSeller === true) || false,
    // labour: laborData.find((item) => item.value === mostFrequentMakeType.type).icon,
    // collectionDetails: Array.isArray(set?.designs?.[0]) ? set.designs[0].filter((d) => Array.isArray(d.collectionDetails) && d.collectionDetails.length > 0).flatMap((d) => d.collectionDetails) : [],
    collectionDetails: Array.isArray(set?.designs?.[0]) ? set.collectionDetails || [] : [],
  };
};

const transformArchivesSetData = (set) => {
  const defaultImageUrl = Default;
  const LaborType = set?.designs[0].map((item) => item?.makeType || "R");

  const labourMap = new Map();
  for (let i = 0; i < LaborType.length; i++) {
    if (labourMap.has(LaborType[i])) {
      labourMap.set(LaborType[i], labourMap.get(LaborType[i]) + 1);
    } else {
      labourMap.set(LaborType[i], 1);
    }
  }

  const mostFrequentMakeType = [...labourMap.entries()].reduce(
    (max, [type, count]) => {
      return count > max.count ? { type, count } : max;
    },
    { type: null, count: 0 }
  );

  // Create an array of images, slicing the first 4 and filling missing with the default image
  // const designsImgs = [...set?.designImages?.slice(0, 4).map((design) => ({ image: design.imageUrl })), ...Array(Math.max(0, 4 - set.designImages.length)).fill({ image: defaultImageUrl })];

  const designsImgs = [
    ...set.designs
      .flat()
      .slice(0, 4)
      .map((design) => ({
        image: design?.images?.[0]?.imageUrl || defaultImageUrl,
      })),
    ...Array(Math.max(0, 4 - set.designs.flat().length)).fill({ image: defaultImageUrl }),
  ];

  return {
    _id: set._id,
    setNumber: set.setNumber,
    // totalDiamonds: `${set.totalDiaPcs}/${set.totalDiaWeight.toFixed(2)}`,
    // goldWeights: `${set.totalGoldGrossWeight.toFixed(2)}/${set.totalGoldWeight.toFixed(2)}`,
    totalDiamonds: `${set.totalDiaWeight.toFixed(2)} Ct /${set.totalDiaPcs} Pcs`,
    goldWeights: `${set.totalGoldWeight.toFixed(2)} g /${set.totalGoldGrossWeight.toFixed(2)} g`,
    numberOfStyles: set.numberOfStyles,
    // date: new Date(set.createdAt).toLocaleDateString("en-GB"),
    date: formatDate(set.createdAt),
    designsImgs,
    labour: mostFrequentMakeType.type,
    sales: set.totalSales,
    trendUp: true,
    cup: cupData.find((item) => item.value === "GoldCup")?.icon,
    bestSeller: false,
    // labour: laborData.find((item) => item.value === "H").icon,
  };
};

//for the set tray modal
const transformDataForTrayModal = (design) => {
  const obj = {
    id: design._id ? design._id : design.id,
    // labour: design.makeType ? design.makeType : design.labour,
    // date: design.styleDate ? new Date(design.styleDate).toLocaleDateString("en-GB") : design.date,
    date: design.styleDate ? formatDate(design?.styleDate) : design.date,
    // gold: design.styleNumber ? design.styleNumber : design.gold,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // weight: design.grossWeight ? `${design.grossWeight}/${design.netWeight}` : design.weight,
    diamond: `${design.diaWeight || 0} Ct / ${design.diaPcs || 0} Pcs`,
    weight: design.grossWeight ? `${design.netWeight || 0} g / ${design.grossWeight || 0} g` : design.weight || `0 g / 0 g`,
    colorStoneWeight: design?.colorStoneWeight || 0.0,
    colorStonePcs: design?.colorStonePcs || 0,
    otherMaterialWeight: design?.otherMaterialWeight || 0.0,
    otherMaterialPcs: design?.otherMaterialPcs || 0,
    collectionDetails: design.collectionDetails || [],
    setDetails: design.setDetails || [],
    Orgimg: design.images ? design?.images[0]?.imageUrl : design?.img ? design?.img : design?.imageUrl,
    img: design.images ? design?.images[0]?.transformedImageUrl : design?.img ? design?.img : design?.transformedImageUrl,
    // img: design?.transformedImageUrl,
    // Orgimg: design?.imageUrl,
    sales: design?.totalSales || 0,
    trendUp: true,
    cup: cupData.find((item) => item.value === design?.currentTrophy)?.icon || null,
    bestSeller: design?.bestSeller ? true : false,
    labour: laborData.find((item) => item.value === design?.makeType)?.icon || design.labour || null,
    designClass: deginType.find((item) => item.value === design?.designClass?.toLowerCase())?.icon,
    styleNumber: design?.styleNumber || null,
    totalTrophy: design?.totalTrophy || null,
    cadIcon: design?.cadIcon || false,
    stockCount: design?.stocks || null,
    categoryName: design?.categoryName || null,
    subCategoryName: design?.subCategoryName || null,
    itemSize: design?.itemSize || null,
    diaQlty: design?.diaQlty || "VVS-GH",
    goldQlty: design?.goldQlty || "18",
    goldColor: design?.goldColor || "P",
    relavantSetsDesign: design?.relavantSetsDesign?.length > 0 ? design?.relavantSetsDesign : [],
    styleOrderCount: design?.styleOrderCount,
    totalClientSales: design?.totalClientSales,
    reorderData: design?.reorderData || null,
    ratio: design?.ratio ? design?.ratio?.toFixed(2) : "N/A",
    isHidden: design?.isHidden || false,
  };

  return obj;
};

//For used cart page:-
const transformDataForCartPage = (design) => {
  // console.log("design cart transfor before  --------->>>>>>>", design);

  const obj = {
    id: design._id ? design._id : design.id,
    // labour: design.makeType ? design.makeType : design.labour,
    // date: design.styleDate ? new Date(design.styleDate).toLocaleDateString("en-GB") : design.date,
    date: design.styleDate ? formatDate(design?.styleDate) : design.date,
    // gold: design.styleNumber ? design.styleNumber : design.gold,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // weight: design.grossWeight ? `${design.grossWeight}/${design.netWeight}` : design.weight,
    // diamond: design.diaPcs ? `${design.diaWeight || design.diaWt} Ct / ${design.diaPcs} Pcs` : design.diamond,
    diamond: (design.diaPcs ?? 0) > 0 ? `${design.diaWeight || design.diaWt || 0} Ct / ${design.diaPcs} Pcs` : `${design.diaWeight || design.diaWt || 0} Ct / 0 Pcs`,
    weight: design.grossWeight ? `${design.netWeight} g / ${design.grossWeight} g` : design.weight || `${design.netWt || 0} g / ${design.grossWt || 0} g`,
    colorStoneWeight: design?.colorStoneWeight || 0.0,
    colorStonePcs: design?.colorStonePcs || 0,
    otherMaterialWeight: design?.otherMaterialWeight || 0.0,
    otherMaterialPcs: design?.otherMaterialPcs || 0,
    itemSize: design?.itemSize || null,
    collectionDetails: design.collectionDetails || [],
    setDetails: design.setDetails || [],
    img: design.images ? design?.images[0]?.imageUrl : design?.img ? design?.img : design?.imageUrl,
    // Orgimg: design?.Orgimg ? design?.Orgimg : design?.images[0]?.imageUrl,
    Orgimg: design?.Orgimg || design?.images?.[0]?.imageUrl || design?.imageUrl,
    sales: design?.totalSales || design?.sales || 0,
    trendUp: true,
    cup: cupData.find((item) => item.value === design?.currentTrophy)?.icon || design?.cup || null,
    bestSeller: design?.bestSeller ? true : false,
    labour: laborData.find((item) => item.value === design?.makeType)?.icon || design.labour || null,
    designClass: deginType.find((item) => item.value === design?.designClass.toLowerCase()).icon,
    styleNumber: design?.styleNumber || null,
    totalTrophy: design?.totalTrophy || null,
    cadIcon: design?.cadIcon || false,
    stockCount: design?.stockCount || design?.duplicateStockCount || null,
    categoryName: design?.categoryName || "",
    subCategoryName: design?.subCategoryName || "",
    
  };

  return obj;
};

//Used For CatalogProductData:-
const transformDataForCatalogDataPage = (design) => {
  // console.log("design===>>>",design)
  const obj = {
    id: design._id ? design._id : design.id,
    // labour: design.makeType ? design.makeType : design.labour,
    // date: design.styleDate ? new Date(design.styleDate).toLocaleDateString("en-GB") : design.date,
    date: design.styleDate ? formatDate(design?.styleDate) : design.date,
    // gold: design.styleNumber ? design.styleNumber : design.gold,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // weight: design.grossWeight ? `${design.grossWeight}/${design.netWeight}` : design.weight,
    // diamond: design.diaPcs ? `${design.diaWeight ?? design.diaWt} Ct / ${design.diaPcs} Pcs` : `${design.diaWeight ?? design.diaWt} Ct / ${design.diaPcs} Pcs`,
    // weight: design.grossWeight ? `${design.netWeight} g / ${design.grossWeight} g` : `${design.netWeight} g / ${design.grossWeight} g` || `${design.netWt} g / ${design.grossWt} g`,
    diamond: (design.diaWeight ?? design.diaWt) != null && design.diaPcs != null ? `${design.diaWeight ?? design.diaWt} Ct / ${design.diaPcs} Pcs` : design.diamond,

    weight: (design.netWeight ?? design.grossWeight) != null ? `${design.netWeight ?? design.netWt} g / ${design.grossWeight ?? design.grossWt} g` : design.weight,
    collectionDetails: design.collectionDetails || [],
    setDetails: design.setDetails || [],
    colorStoneWeight: design?.colorStoneWeight || 0.0,
    colorStonePcs: design?.colorStonePcs || 0,
    otherMaterialWeight: design?.otherMaterialWeight || 0.0,
    otherMaterialPcs: design?.otherMaterialPcs || 0,
    // img: design.images ? design?.images[0]?.imageUrl : design?.img ? design?.img : design?.imageUrl,
    itemSize: design?.itemSize || null,
    img: design?.transformedImageUrl || design?.img,
    Orgimg: design?.imageUrl || design?.Orgimg,
    sales: design?.totalSales || design?.sales || 0,
    trendUp: true,
    cup: cupData.find((item) => item.value === design?.currentTrophy)?.icon || design?.cup || null,
    bestSeller: design?.bestSeller ? true : false,
    labour: laborData.find((item) => item.value === design?.makeType)?.icon || design.labour || null,
    designClass: deginType.find((item) => item.value === design?.designClass.toLowerCase()).icon,
    styleNumber: design?.styleNumber || null,
    totalTrophy: design?.totalTrophy || null,
    cadIcon: design?.cadIcon || false,
    categoryName: design?.categoryName || null,
    subCategoryName: design?.subCategoryName || null,
    stockCount: design?.stocks || null,
    reorderData: design?.reorderData || null,
    ratio: design?.ratio?.toFixed(2) || "N/A",
    isHidden : design?.isHidden || false,
  };

  return obj;
};

const transformClinet = (design) => {
  const obj = {
    _id: design?.style?._id || design._id,
    view: design.view || 0,
    cart: design.cart || 0,
    clock: convertingSecondIntoHoursFormat(design.clock || 0) || "00:00:00",
    // gold: design?.style?.styleNumber ? design?.style?.styleNumber : design?.style?.gold,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    removeCart: design.removeCart || 0,
    img: design?.imageUrl,
    Orgimg: design?.imageUrl || design?.Orgimg,
    // labour: design?.style?.makeType ? design?.style?.makeType : design?.style?.labour,
    // date: design?.style?.styleDate ? new Date(design?.style?.styleDate).toLocaleDateString("en-GB") : design?.style?.date,
    date: design?.style?.styleDate ? formatDate(design?.style?.styleDate) : design?.style?.date,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // diamond: design?.style?.diaPcs != null && design?.style?.diaWeight != null ? `${design?.style?.diaPcs}/${design?.style?.diaWeight}` : design?.style?.diamond,
    // weight: design?.style?.grossWeight ? `${design?.style?.grossWeight}/${design?.style?.netWeight}` : design?.style?.weight,
    diamond: design?.style?.diaPcs != null && design?.style?.diaWeight != null ? `${design?.style?.diaWeight} Ct / ${design?.style?.diaPcs} Pcs` : design?.style?.diamond,
    weight: design?.style?.grossWeight ? `${design?.style?.netWeight} g / ${design?.style?.grossWeight} g` : design?.style?.weight,
    colorStoneWeight: design?.style?.colorStoneWeight || 0.0,
    colorStonePcs: design?.style?.colorStonePcs || 0,
    otherMaterialWeight: design?.style?.otherMaterialWeight || 0.0,
    otherMaterialPcs: design?.style?.otherMaterialPcs || 0,
    itemSize: design?.itemSize || null,
    sales: design?.style?.totalSales || design?.style?.sales || 0,
    trendUp: true,
    cup: cupData.find((item) => item.value === design?.style?.currentTrophy)?.icon || design?.style?.cup || null,
    bestSeller: design?.bestSeller ? true : false,
    labour: laborData.find((item) => item.value === design?.style?.makeType)?.icon || design?.style?.labour || null,
    designClass: deginType.find((item) => item.value === design?.style?.designClass.toLowerCase()).icon,
    styleNumber: design?.style?.styleNumber || null,
    totalTrophy: design?.style?.totalTrophy || null,
    cadIcon: design?.cadIcon || false,
    totalClientSales: design?.totalClientSales,
    ratio: design?.ratio?.toFixed(2) || "N/A",
  };

  return obj;
};

const transformDataForCreateOrderPage = (design) => {
  const obj = {
    id: design._id ? design._id : design.id,
    // labour: design.makeType ? design.makeType : design.labour,
    // date: design.styleDate ? new Date(design.styleDate).toLocaleDateString("en-GB") : design.date,
    date: design.styleDate ? formatDate(design?.styleDate) : design.date,
    // gold: design.styleNumber ? design.styleNumber : design.gold,
    // diamond: design.diaPcs ? `${design.diaPcs}/${design.diaWeight}` : design.diamond,
    // weight: design.grossWeight ? `${design.grossWeight}/${design.netWeight}` : design.weight,
    // diamond: design.diaPcs ? `${design.diaWeight || design?.diaWt} Ct / ${design.diaPcs} Pcs` : design.diamond,
    // diamond: design.diaPcs ? `${design.diaWeight ?? design.diaWt ?? 0} Ct / ${design.diaPcs} Pcs` : design.diamond,
    colorStoneWeight: design?.colorStoneWeight || 0.0,
    colorStonePcs: design?.colorStonePcs || 0,
    otherMaterialWeight: design?.otherMaterialWeight || 0.0,
    otherMaterialPcs: design?.otherMaterialPcs || 0,

    // Fields for StockCard compatibility
    diaWt: design.diaWeight ?? design.diaWt ?? 0,
    diaPcs: design.diaPcs ?? 0,
    netWt: design.netWeight ?? design.netWt ?? 0,
    grossWt: design.grossWeight ?? design.grossWt ?? 0,
    csWt: design.colorStoneWeight ?? 0,
    csPcs: design.colorStonePcs ?? 0,
    otherWt: design.otherMaterialWeight ?? 0,
    otherPcs: design.otherMaterialPcs ?? 0,
    jewelCode: design.jewelCode || null,
    location: design.location ?? "",
    memoClientName: design.memoClientName ?? "",

    diamond: design.diamond ? design.diamond : `${design.diaWeight || design.diaWt || 0} Ct / ${design.diaPcs || 0} Pcs`,
    weight: design.weight ? design.weight : ` ${design.netWeight || design.netWt || 0} g / ${design.grossWeight || design.grossWt || 0} g`,
    setDetails: design.setDetails || [],
    img: design.images ? design?.images[0]?.imageUrl : design?.img ? design?.img : design?.imageUrl,
    // Orgimg: design?.Orgimg ? design?.Orgimg : design?.images[0]?.imageUrl,
    Orgimg: design?.Orgimg || design?.images?.[0]?.imageUrl,
    sales: design?.totalSales || design?.sales || 0,
    trendUp: true,
    cup: cupData.find((item) => item.value === design?.currentTrophy)?.icon || design?.cup || null,
    bestSeller: design?.bestSeller ? true : false,
    labour: laborData.find((item) => item.value === design?.makeType)?.icon || design.labour || null,
    designClass: deginType.find((item) => item.value === design?.designClass?.toLowerCase())?.icon,
    styleNumber: design?.styleNumber || null,
    totalTrophy: design?.totalTrophy || null,
    cadIcon: design?.cadIcon || false,
    stockCount: design?.stockCount || null,
    // Categories: design?.Category || null,
    message: design?.message || null,
    itemSize: design?.itemSize || null,
    diaQlty: design?.diaQlty || "VVS-GH",
    goldQlty: design?.goldQlty || "18",
    goldColor: design?.goldColor || "P",
    rhodium: design?.rhodium || "W",
    itemPoNo: design?.itemPoNo || null,
    categoryName: design?.categoryName || null,
    subCategoryName: design?.subCategoryName || null,
    relavantSetsDesign: design?.relavantSetsDesign?.length > 0 ? design?.relavantSetsDesign : [],
    cartItemId: design?.cartItemId || null,
  };

  return obj;
};

const transformUspData = (data) => {
  if (!data) return null;

  return {
    designNumber: data?.styleNumber || "",
    designClass: data?.designClass || "",
    diamondInfo: `${data?.diaWeight ?? 0} Ct / ${data?.diaPcs ?? 0} Pcs`,
    weightInfo: `${data?.grossWeight ?? 0} g / ${data?.netWeight ?? 0} g`,
    bagCount: data?.totalSales ?? 0,
    date: data?.styleDate ? formatDate(data?.styleDate) : data?.styleDate,
    imageUrl: data?.transformedImageUrl || data.imageUrl || "",
  };
};

const transformStockData = (data) => {
  if (!data) return null;

  return {
    _id: data?._id || null,
    jewelId: data?.JewelId || null,
    jewelCode: data?.JewelCode || "",
    __v: 0,
    baseMetalCode: data?.BaseMetalCode || "",
    baseStoneCode: data?.BaseStoneCode || "",
    createdAt: data?.CreatedAt || null,
    csPcs: data?.["CS Pc"] ?? 0,
    csWt: data?.["CS Wt"] ?? 0,
    diaPcs: data?.["Dia Pc"] ?? 0,
    diaQlty: data?.DiaQlty || "-",
    diaWt: data?.["Dia Wt"] ?? 0,
    goldColor: data?.GoldColor === "P" ? "Pink" : data?.GoldColor === "Y" ? "Yellow" : data?.GoldColor === "W" ? "White" : data?.GoldColor || "",
    goldQlty: data?.GoldQlty || "",
    grossWt: data?.GrossWt ?? 0,
    itemSize: data?.ItemSize || "N/A",
    makeDate: data?.MakeDate || null,
    memoClientName: data?.MemoClientName || "",
    orderClientName: data?.orderClientName || "",
    netWt: data?.NetWt ?? 0,
    otherPcs: data?.["Other Metal Pc"] ?? 0,
    otherWt: data?.["Other Metal Wt"] ?? 0,
    status: data?.Status || "On Hand",
    styleNumber: data?.StyleCode || "",
    updatedAt: data?.UpdatedAt || null,
    id: data?.JewelTransId?.toString() || "",
    styleDate: data?.StyleDate || null,
    bestSeller: data?.bestSeller || false,
    designClass: data?.designClass || "Bronze",
    totalSales: data?.TotalSales || 0,
    categoryName: data?.CategoryName || "",
    collectionDetails: data?.CollectionDetails || [],
    setDetails: data?.SetDetails || [],
    relavantSetsDesign: data?.RelavantSetsDesign || [],
    imageUrl: data?.ImageUrl || "",
    transformedImageUrl: data?.TransformedImageUrl || "",
  };
};

export {
  transformData,
  transformSetData,
  transformArchivesSetData,
  transformDataForTrayModal,
  transformClinet,
  transformDataForCartPage,
  transformDataForCatalogDataPage,
  transformDataForCreateOrderPage,
  transformUspData,
  transformStockData,
};
